var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C4.86 3 2.167 4.91 1.072 7.626a1 1 0 0 0 0 .748C2.167 11.089 4.86 13 8 13s5.833-1.91 6.928-4.626a1 1 0 0 0 0-.748C13.832 4.911 11.14 3 8 3zm0 8c-2.165 0-4.024-1.23-4.904-3C3.976 6.23 5.835 5 8 5s4.024 1.23 4.905 3c-.88 1.77-2.74 3-4.905 3zm2-3a2 2 0 1 1-1.411-1.912 1 1 0 1 0 1.323 1.323A2 2 0 0 1 10 8z"
  })));
};
export default SvgEye;